import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection'
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider'
import MaximizeModal from '../../Components/mumbai/MaximizeModal'
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection'
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection'
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper'
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection'
import LocationForm from '../../Components/mumbai/LocationForm'
import WhyChoose from '../../Components/mumbai/WhyChoose'
import EngagementModels from '../../Components/hire/EngagementModels'
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm'

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "Mobikode supports Abu Dhabi businesses with reliable solutions, dedicated assistance, and continuous care to drive lasting digital success.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "Empowering Abu Dhabi businesses with smart digital solutions that simplify operations, enhance experiences, and drive sustainable growth.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Mobikode helps Abu Dhabi businesses grow with tailored digital solutions that simplify operations, enhance efficiency, and deliver lasting value.",
        image: "/assets/mumbai/img2.png"
    },

];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "Mobikode helps Abu Dhabi’s financial businesses streamline operations, enhance customer experiences, and achieve sustainable growth through secure, reliable, and innovative digital technology solutions tailored to their needs.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "Mobikode helps Abu Dhabi’s eCommerce businesses grow with smart digital solutions, seamless experiences, and reliable technology that simplifies operations and supports long-term success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Mobikode helps Abu Dhabi’s insurance companies modernize operations, enhance customer experiences, simplify claims and policy management, and achieve sustainable growth through secure, intelligent, and innovative digital solutions.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "Mobikode helps Abu Dhabi’s manufacturing businesses adopt smarter technologies, streamline operations, boost productivity, and create efficient digital solutions that drive sustainable growth and business success.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "Mobikode helps Abu Dhabi’s retail and consumer brands thrive with smart digital solutions that enhance customer experiences, streamline operations, and enable sustainable business growth.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "Mobikode partners with Healthcare & Life Sciences organizations in Abu Dhabi to deliver smart digital solutions that enhance patient experiences, streamline operations, and support better healthcare outcomes.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode empowers Abu Dhabi’s media and communication businesses with innovative digital solutions that blend technology and creativity to engage audiences, simplify operations, and strengthen brand connections.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "Mobikode helps Abu Dhabi’s logistics and transportation businesses streamline operations, enhance delivery experiences, and drive growth with smart, reliable digital solutions built around their unique needs.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "Mobikode helps Abu Dhabi technology companies transform ideas into smart digital solutions. We combine innovation, creativity, and expertise to build reliable technology that drives growth and success.",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "Mobikode empowers Abu Dhabi’s non-profit organizations with smart digital solutions that simplify operations, strengthen community connections, and help them create meaningful, lasting social impact.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "Mobikode helps professional service businesses in Abu Dhabi streamline operations, adopt smarter technologies, and deliver exceptional client experiences with reliable, customized digital solutions built for growth.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "Mobikode helps Abu Dhabi’s real estate businesses thrive with smart digital solutions that streamline operations, enhance customer journeys, and build meaningful connections between developers, agents, and buyers.",
        image: "/assets/mumbai/item12.png"
    },

];

function AbuDhabi() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Abu Dhabi | Enterprise Service Management | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode delivers ServiceNow consulting in Abu Dhabi to streamline enterprise service management, automate workflows, integrate business systems, and improve operational efficiency."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Abu Dhabi, ServiceNow Consultant Abu Dhabi, ServiceNow ITSM Abu Dhabi, ServiceNow Enterprise Service Management Abu Dhabi, ServiceNow Workflow Automation Abu Dhabi, ServiceNow Implementation Abu Dhabi, ServiceNow Integration Abu Dhabi, ServiceNow Managed Services Abu Dhabi, ServiceNow Development Abu Dhabi, ServiceNow Digital Transformation Abu Dhabi"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-abudhabi"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Abu Dhabi | Enterprise Service Management | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Improve enterprise operations with Mobikode's ServiceNow consulting services in Abu Dhabi. Automate workflows, strengthen IT service management, connect business systems, and create scalable digital processes."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-abudhabi"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/abudhabi/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Abu Dhabi | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore ServiceNow solutions in Abu Dhabi for ITSM, enterprise service management, workflow automation, system integration, and efficient digital operations with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/abudhabi/bg1.png"
                />
            </Helmet>

            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Abu Dhabi" description="Partner with Mobikode’s ServiceNow experts in Abu Dhabi to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/AbuDhabi.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />
            {/* <ServiceSection image={"/assets/mumbai/AbuDhabi.png"}
                text={"At Mobikode, we help businesses in Abu Dhabi unlock the full potential of ServiceNow through smart consulting, seamless implementation, and customized solutions. Our experts simplify complex processes, automate workflows, and improve operational efficiency with reliable ServiceNow services. We work closely with organizations to create better digital experiences and support sustainable business growth."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="Mobikode helps Abu Dhabi businesses unlock ServiceNow’s full potential with personalized consulting, intelligent automation, and seamless digital solutions that simplify operations, enhance efficiency, and drive growth." />
            <HireDeveloper /> */}
        </div>
    )
}

export default AbuDhabi
